import React from 'react'

const LoadingInline = React.memo(props => (
    <div className={'d-inline-block ' + (props.className || '')}>
        <div className='spinner-border spinner-sm loading-icon' role='status'>
            <span className='sr-only'>Loading...</span>
        </div>
        {(props.text && <small className='d-block text-muted mt-1'>{props.text}</small>) || null}
    </div>
))

export default LoadingInline
